import * as React from 'react';
import { useDrawerDirection, Drawer } from '@grandvisionhq/common';
import { ProductDetailDrawerCTA } from './ProductDetailDrawerCTA.js';

const ProductDetailDrawer = ({ title , ctaButton , children , 'data-t': dataT , shouldMountContent ,  })=>{
    const drawerDirection = useDrawerDirection();
    const isRightDirection = drawerDirection === 'right';
    const Title = isRightDirection ? undefined : ({ className  })=>/*#__PURE__*/ React.createElement(Drawer.Title, {
            className: className
        }, title)
    ;
    const drawerCTA = ctaButton !== null && ctaButton !== void 0 ? ctaButton : /*#__PURE__*/ React.createElement(ProductDetailDrawerCTA, {
        title: title,
        "data-t": `${dataT}-trigger`
    });
    return /*#__PURE__*/ React.createElement(Drawer, {
        direction: drawerDirection
    }, drawerCTA, /*#__PURE__*/ React.createElement(Drawer.Backdrop, null), /*#__PURE__*/ React.createElement(Drawer.Overlay, {
        "data-t": dataT,
        shouldMountContent: shouldMountContent
    }, /*#__PURE__*/ React.createElement(Drawer.Header, {
        Title: Title
    }), !isRightDirection && /*#__PURE__*/ React.createElement(Drawer.Divider, null), /*#__PURE__*/ React.createElement(Drawer.Content, null, isRightDirection && /*#__PURE__*/ React.createElement(Drawer.Title, null, title), children)));
};

export { ProductDetailDrawer };
//# sourceMappingURL=ProductDetailDrawer.js.map
